<template lang="pug">
  .main
    .inner_block(v-for="value in data")
      h3(v-if="value == data[0]") Оценка анализа
      h3(v-if="value == data[1]") Оценка рекомендаций
      h3(v-if="value == data[2]") Статусы обратной связи
      table.simpletable
        thead
          th Cтатус
          th Количество
          th Доля
        tr(v-for="item in value.table.body")
          td {{item[0]}}
          td(style="text-align: center") {{item[1]}}
          td(style="text-align: center") {{item[2]}}
</template>
<script>
export default {
  props: ['data']
}
</script>
<style lang="sass" scoped>
.simpletable
  margin-bottom: 40px
  border-collapse: collapse
.simpletable td,
.simpletable th
  border: 1px solid #ccc
  padding: 10px
  vertical-align: middle
.simpletable thead th
  font-weight: bold
  text-align: center
.inner_block
  margin-left: 130px
  display: inline-block
  float: left
thead
  background-color: #074d59
th
  color: white
h3
  font-size: 25px
  font-weight: normal
  margin-bottom: 20px
  text-align: center
</style>
